// extracted by mini-css-extract-plugin
module.exports = {"coursesListWrapper":"CoursesList_coursesListWrapper__0_k2G","noCourse":"CoursesList_noCourse__TAKQy"};